<template>
    <div class="loginform">
        <img src="./assets/img/logo.png" alt="" class="logo">
        <div class="box">
          <div class="tit">登录</div>
          <div class="app-weui-cells weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label">手机号</label></div>
                <div class="weui-cell__bd"><input v-model="account" class="weui-input" type="tel" placeholder="请输入手机号"></div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label">密码</label></div>
                <div class="weui-cell__bd"><input v-model="password" class="weui-input" type="password" placeholder="请输入密码"></div>
            </div>
            <div class="weui-cell weui-cell_vcode">
                <div class="weui-cell__hd"><label class="weui-label">图形验证码</label></div>
                <div class="weui-cell__bd">
                    <input v-model="captcha" class="weui-input" type="text" placeholder="请输入图形验证码"/>
                </div>
                <img v-if="captcha_info.captcha_url" @click="getcaptcha()" v-bind:src="publics.HOST+captcha_info.captcha_url" alt="" class="imgyzm">
            </div>
          </div>
        </div>

        <div class="other">
          <router-link :to="{ name: 'register' }" class="fl">新用户注册</router-link>
          <router-link :to="{ name: 'forgetpassword' }" class="fr">忘记密码</router-link>
        </div>

        <div class="app-btn-area weui-btn-area">
            <button @click="submit()" v-bind:disabled="subdisabled" class="weui-btn" :class="[subdisabled?'disabled':'']">登录</button>
        </div>
    </div>
</template>
<script>
  export default {
    data() {
        return {
            captcha_info:'',
            account:'',
            password:'',
            captcha:''
        }
    },
    computed:{
      subdisabled(){
        return !(this.account && this.password && this.captcha)
      }
    },
    mounted() {
      this.getcaptcha();
    },
    methods: {
      getcaptcha(){
        let vm = this;
        vm.ajax("captcha", "get", '', e => {
          vm.captcha_info = e.data;
        })
      },
      submit() {
        var vm = this;
        if (!vm.account) {
            vm.publics.message.danger('请输入账号');
            return false;
        }
        if (!vm.password) {
            vm.publics.message.danger('请输入密码');
            return false;
        }
        if(!vm.captcha){
          vm.publics.message.danger('请输入正确的图形验证码');
          return false;
        }
        vm.ajax("login", "post", {
          account:vm.account,
          password:vm.password,
          captcha:vm.captcha,
          captcha_id:vm.captcha_info.captcha_id
        }, e => {
          if(e.code == "1000"){
            setTimeout(function(){
                vm.$router.replace('/')
            },1000)
          }else{
            vm.getcaptcha();
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/login.vue